import * as types from '../constants/ActionTypes'

export function openPopup(name, content) {
  return {
    name,
    content,
    type: types.OPEN_POPUP,
  }
}

export function clearPopup() {
  return {
    type: types.CLEAR_POPUP,
  }
}

export function closePopup() {
  return {
    type: types.CLOSE_POPUP
  }
}